import { useEffect, useState } from "react";

import {
    Chip,
    TextField,
    MenuItem,
} from "@mui/material";

import MUIDataTable from "mui-datatables";

import { useNavigate } from "react-router-dom";

import { paymentsApi } from "../API/paymentsApi";
import { paymentGatewayApi } from "../API/paymentGatewayApi";
import GatewayLogo from "./GatewayLogo";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import TextfieldComponent from "../Component/TextfieldComponent";
import SelectField from "../NewUI/NewComponents/SelectField";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb";

export default function PaymentList() {

    const navigate = useNavigate();

    const [rows, setRows] = useState([]);

    const [loading, setLoading] = useState(false);

    const [status, setStatus] = useState("");

    const [search, setSearch] = useState("");

    const [gatewayLogos, setGatewayLogos] = useState({});

    const loadPayments = async () => {

        try {

            setLoading(true);

            const params = {};
            if (status && status !== 'All') params.paymentStatus = status;
            if (search?.trim()) params.referenceNumber = search.trim();
            const response = await paymentsApi.search(params);

            setRows(response.data?.content || []);

        } catch (e) {
            setRows([]);
        } finally {

            setLoading(false);

        }
    };

    useEffect(() => {
        loadPayments();
        paymentGatewayApi.getAll().then((res) => {
            const list = res.data?.data || res.data || [];
            const map = {};
            list.forEach((g) => {
                if (g.code) map[g.code] = g.logoUrl;
                if (g.displayName) map[g.displayName] = g.logoUrl;
            });
            setGatewayLogos(map);
        }).catch(() => {});
    }, [status]);

    const columns = [

        {
            name: "paymentId",
            label: "ID",
        },

        {
            name: "referenceNumber",
            label: "Reference",
        },

        {
            name: "orderId",
            label: "Order",
        },

        {
            name: "gatewayName",
            label: "Gateway",
            options: {
                customBodyRender: (v, m) => {
                    const name = v || m.rowData[4] || '';
                    const logo = gatewayLogos[m.rowData[4]] || gatewayLogos[name];
                    return (
                        <span className="tw-inline-flex tw-items-center tw-gap-2">
                            {logo ? <GatewayLogo logoUrl={logo} size={22} /> : null}
                            <span>{name}</span>
                        </span>
                    );
                },
            },
        },

        {
            name: "gatewayCode",
            label: "Gateway Code",
            options: { display: false },
        },

        {
            name: "amount",
            label: "Amount",
            options: {
                customBodyRender: (value) =>
                    `₹${value}`,
            },
        },

        {
            name: "paymentStatus",
            label: "Status",
            options: {
                customBodyRender: (value) => {

                    const color =
                        value === "SUCCESS"
                            ? "success"
                            : value === "FAILED"
                                ? "error"
                                : "warning";

                    return (
                        <Chip
                            label={value}
                            color={color}
                            size="small"
                        />
                    );
                },
            },
        },

        {
            name: "paymentId",
            label: "Actions",
            options: {
                customBodyRender: (value) => (

                    <button
                        className="btn btn-sm hovbuttonColour"
                        onClick={() =>
                            navigate(
                                `/payments/${value}`
                            )
                        }
                    >
                        View
                    </button>

                ),
            },
        },
    ];

    const options = {
        filterType: "dropdown",
        selectableRows: "none",
        responsive: "standard",
    };

    return (

        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <div className="UI-container">
                    <div className="UI-card">
                        <div className="UI-header">
                            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/superadminmasters" }, { name: "Payments Dashboard", path: null }]} />
                            <div className="UI-header-content">

                                <div>
                                    <h1 className="UI-title">
                                        Payments
                                    </h1>
                                    <p className="UI-subtitle">
                                        List of all payments
                                    </p>
                                </div>
                                <div className="UI-header-actions">
                                    <div className="tw-flex tw-flex-row tw-gap-2 tw-items-end">
                                        <TextfieldComponent
                                            label="Search Reference"
                                            value={search}
                                            onChange={(e) =>
                                                setSearch(e.target.value)
                                            }
                                        />

                                        <SelectField
                                            label="Status"
                                            value={status}
                                            className="tw-w-18 !tw-pb-1"
                                            onChange={(e) =>
                                                setStatus(e.target.value)
                                            }
                                            list={["All", "PENDING", "AUTHORIZED", "SUCCESS", "FAILED", "CANCELLED", "REFUNDED"]}
                                        />

                                        <div className="UI-form-group tw-pb-1">
                                            <label className="UI-label">&nbsp;</label>
                                            <button
                                                className="UI-btn UI-btn-primary tw-whitespace-nowrap"
                                                onClick={loadPayments}
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="UI-form-container">

                            <MUIDataTable
                                title=""
                                data={rows}
                                columns={columns}
                                options={options}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}